import Vue from 'vue';
import ProfileForm from '@/components/pages/ProfilePage/ProfileForm.vue'

Vue.component('profile-form', ProfileForm);
